export const questionTypes = {
    MULTIPLE_RATING: "multiple-rating",
    RECORD: "record",
    SINGLE_RATING: "single-rating",
    TEXT: "text",
    YES_NO: "yes-no"
}